






















































































import { Component, Vue, State, Prop, Ref, Watch } from 'nuxt-property-decorator'
import { IconDelete, IconChevronDown } from '@klook/klook-icons'
import { recordSearchHistory, getSearchHistoryData, removeSearchHistoryData, SearchHistoryItem as SearchHistoryItemType } from '~/components/tour/destination-search/utils'

@Component({
  components: {
    IconDelete,
    IconChevronDown
  }
})
export default class SearchHistory extends Vue {
  @State((state) => state.klook.platform) platform!: Data.Platform
  @Prop({ default: false }) visible!: boolean
  @Ref() searchHistoryContent!: any

  modalVisible: boolean = false
  searchHistory: SearchHistoryItemType[] = []
  isDeleted: boolean = false
  showFooter: boolean = false
  observeDom: null | HTMLElement = null
  elementObserver: any = null
  recordHeight: number = 0 // 记录最大高度
  paddingBottom: number = 12

  @Watch('visible', { immediate: true })
  onVisibleChange(val: boolean) {
    if (process.client) {
      if (val) {
        this.calcHeight()
      } else {
        this.observeDom && (this.observeDom.style.maxHeight = 'none')
        this.destroyObserver()
      }
    }
  }

  get isDesktop() {
    return this.platform === 'desktop'
  }

  get limit() {
    // desktop: 48 * 2  mweb: 48 * 3
    return this.isDesktop ? 96 : 144
  }

  genSpm(item: SearchHistoryItemType, idx: number) {
    const ext: any = {
      RecommendType: 'SearchHistory',
      query: (item.text || []).join(''),
      ...(item.payload || {})
    }

    return `Recommendation_LIST?idx=${idx}&len=${this.searchHistory.length}&ext=${encodeURIComponent(JSON.stringify(ext))}`
  }

  handleClick(item: SearchHistoryItemType) {
    const { payload, url, text } = item
    recordSearchHistory(text, url, payload)
  }

  handelConfirm() {
    this.searchHistory = []
    this.isDeleted = true
    this.visible = false
    removeSearchHistoryData()
  }

  getSearchHistory() {
    this.searchHistory = getSearchHistoryData() || []
  }

  expand() {
    if (this.observeDom) {
      this.showFooter = false
      // padding-bottom: 12px
      this.observeDom.style.maxHeight = this.recordHeight - this.paddingBottom + 'px'
    }
  }

  genTarget(item: SearchHistoryItemType) {
    if (item?.payload?.suggestType === 'Explore') {
      return '_blank'
    }

    return '_self'
  }

  createObserver() {
    if ('IntersectionObserver' in window) {
      this.elementObserver = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            // 如果元素可见
            if (entry.intersectionRatio > 0) {
              this.$nextTick(() => {
                this.calcHeight()
                // 只监听一次，否则会一直计算高度
                this.destroyObserver()
              })
            }
          })
        },
        { threshold: [0.1] }
      )

      this.searchHistoryContent && this.elementObserver.observe(this.searchHistoryContent)
    }
  }

  calcHeight() {
    this.$nextTick(() => {
      if (this.$el?.querySelector) {
        const target = this.$el.querySelector('.search-history-box-wrapper-body-content')

        if (target) {
          const { scrollHeight } = target
          this.observeDom = target as HTMLElement

          if (scrollHeight > this.limit) {
            this.showFooter = true
            this.recordHeight = scrollHeight
            ;(target as HTMLElement).style.maxHeight = this.limit - this.paddingBottom + 'px'
          } else if (scrollHeight === 0) {
            this.createObserver()
          } else {
            (target as HTMLElement).style.maxHeight = scrollHeight - this.paddingBottom + 'px'
          }
        }
      }
    })
  }

  destroyObserver() {
    this.elementObserver && this.observeDom && this.elementObserver.unobserve(this.observeDom)
  }

  beforeDestroy() {
    this.destroyObserver()
  }

  mounted() {
    this.getSearchHistory()
  }
}
